
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Cl_common } from "@/functions/Cl_common";
import { Cl_bank } from "@/functions/Cl_bank";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";

import "vue-good-table-next/dist/vue-good-table-next.css";
import { VueGoodTable } from "vue-good-table-next";
import { DtoBanksGetReqImple } from "mediadept-common/src/common/dto/DtoBanksGetReqImple";
import { DtoBanksGetResImple } from "mediadept-common/src/common/dto/DtoBanksGetResImple";
import { CONST_LIST_DEFO_COUNT } from "@/constants/constant";
import { Cl_filemaster } from "@/functions/Cl_filemaster";
import { DtoFileMastersGetReqImple } from "mediadept-common/src/common/dto/DtoFileMastersGetReqImple";

import { CONST_BANK_NAME } from "mediadept-common/src/common/constant/Constants";

@Options({
  components: {
    vSelect,
    VueGoodTable,
    Mo_modal_alert,
  },
})
export default class Kouzalist extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoBanksGetResImple();
  //ボタン制御用
  btnDisable = false;
  //検索条件dom
  domBankName = "";
  domBranchName = "";
  domBankNumber = "";
  domBankType = "";

  // optionsOp = [
  //   { label: "みずほ銀行", code: 1 },
  //   { label: "りそな銀行", code: 2 },
  //   { label: "三井住友銀行", code: 3 },
  //   { label: "三菱UFJ銀行", code: 4 },
  // ];

  optionsOp2 = [
    { label: "当座預金", code: 1 },
    { label: "普通預金", code: 2 },
  ];
  columns = [
    {
      label: "詳細",
      field: "btnDet",
      width: "10%",
    },
    {
      label: "銀行名",
      field: "c_bank_name",
    },
    {
      label: "支店名",
      field: "c_bank_branch_name",
    },
    {
      label: "口座種別",
      field: "c_bank_type",
    },
    {
      label: "口座番号",
      field: "c_bank_number",
    },
  ];

  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalErrorConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.getlist(1);
  }
  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * 一覧データを読み込む
   */
  async getlist(currentPage: number) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoBanksGetReqImple();

      //検索条件設定
      // dto.pager.count = CONST_LIST_DEFO_COUNT;
      dto.pager.count = 9999;
      dto.pager.cursor = currentPage;

      dto.bankName = this.domBankName;
      dto.branchName = this.domBranchName;
      dto.bankNumber = this.domBankNumber;
      if (this.domBankType != "" && this.domBankType != null)
        dto.bankType = Number(this.domBankType);

      //API実行
      //-------
      this.delegate = await Cl_bank.getList(dto);
      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      //エラー発生で一覧を初期化
      this.delegate = new DtoBanksGetResImple();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * ファイルをダウンロードする
   */
  async dl() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoFileMastersGetReqImple();
      dto.type = "KouzaList";
      dto.name = this.domBankName;
      dto.name2 = this.domBranchName;
      dto.type2 = Number(this.domBankType);
      dto.strNumber = this.domBankNumber;
      //API実行
      //-------
      const res = await Cl_filemaster.get(dto);

      //レスポンス処理
      //-------
      location.href = res.url;
      //window.open(res.url, "_blank");
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  async moveDet(id: string) {
    //詳細ページに移動
    this.$router.push("/kouzaedit?id=" + id);
  }
  /**
   * ページ更新時の処理
   * @param params
   */
  async onPageChange(params: any) {
    //テーブル更新処理
    await this.getlist(params.currentPage);
  }
  /**
   * ソート変更時の処理
   * @param params
   */
  async onSortChange(params: any) {
    //テーブル更新処理
  }
  /**
   * 画面遷移用
   * @param url
   * @param event
   */
  async goTo(url: string, event?: MouseEvent) {
    Cl_common.goTo(url, this.$router, event);
  }
  /**
   * 銀行名を返す
   */
  getBankName(bankNumber: number) {
    return CONST_BANK_NAME[bankNumber];
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
}
